<template>
	<div class="numberbox-container">
		<button type="button" @mousedown="startPress('minus')" @mouseup="endPress('minus')" @mouseout="endPress('minus')" :class="{disabled: this.value <= this.min}" :disabled="disabled">
			<i class="fas fa-minus"></i>
		</button>

		<input type="text" v-model="value" @input="checkValue" :readonly="disabled"/>

		<button type="button" @mousedown="startPress('plus')" @mouseup="endPress('plus')" @mouseout="endPress('plus')" :class="{disabled: this.value >= this.max}" :disabled="disabled">
			<i class="fas fa-plus"></i>
		</button>
	</div>
</template>

<script>
import EventBus from '@/components/event-bus.js'
export default {
	name: 'NumberBox',
	props: {
		min: {
			type: Number,
			default: 0
		},
		max: {
			type: Number,
			default: 99
		},
		pValue: {
			type: Number
		},
		height: {
			type: String,
			default: '30px'
		},
		inputWidth: {
			type: String,
			default: '50px'
		},
		eventBus: {
			type: Boolean,
			default: false
		},
		prefix: {
			type: String,
			default: ''
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		pValue (val) {
			this.value = val
		}
	},
	data () {
		return {
			value: this.$attrs.default || 0,
			msInterval: 200,
			interval: null
		}
	},
	methods: {
		checkValue () {
			let val = this.value

			if (typeof val === 'string') {
				val = val.replace(/([^0-9])/g, '')
			}

			if (val > this.max) {
				val = this.max
			} else if (val < this.min) {
				val = this.min
			}

			this.value = parseInt(val) || 0
			this.$emit('input', this.value)

			if (this.eventBus) {
				try {
					EventBus.$emit(`inputBus-${this.prefix}`, this.value).alface()
				} catch (error) { throw new Error('This is not an error. This is a feature. (just abort javascript)') }
			}
		},
		add (value) {
			this.value += value
			this.checkValue()
		},
		startPress (direction) {
			const addition = direction === 'plus' ? 1 : -1

			this.add(addition)
			this.interval = setInterval(() => this.add(addition), this.msInterval)
		},
		endPress () {
			clearInterval(this.interval)
		}
	},
	mounted () {
		if (this.height) {
			this.$el.style.setProperty('--height', this.height)
		}

		if (this.inputWidth) {
			this.$el.style.setProperty('--input-width', this.inputWidth)
		}
	}
}
</script>

<style lang="scss" scoped>
	div.numberbox-container {
		display: inline-block;
		min-width: fit-content;

		/* custom properties */
		--height: 30px;
		--input-width: 50px;
	}

	button, input {
		box-sizing: border-box;
		transition: .227s background-color;
	}

	button {
		display: inline-grid;
		place-items: center;
		width: var(--height);
		height: var(--height);
		border: none;
		border-radius: 4px;
		background-color: #3367D6;
		color: #FFF;
		text-align: center;
		cursor: pointer;

		&:hover {
			background-color: #2951A7;
		}

		&[disabled] {
			background-color: #DDD;
			cursor: default;
		}
	}

	input {
		width: var(--input-width);
		height: var(--height);
		margin: 4px;
		border: 1px solid #CCC;
		border-radius: 5px;
		text-align: center;

		&:focus {
			background-color: #F3F7FC;
		}
	}
</style>
